

















































































































































































































































































import CreditCardForm from '@/components/payments/CreditCardForm.vue';
import GetSonyPaymentToken from '@/components/payments/GetSonyPaymentToken.vue';
import SavedCardForm from '@/components/payments/SavedCardForm.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { SubscriptionInfo } from '@/models/Subscription';
import { InputCard } from '@/models/InputCard';
import { EventItem, EventOptionItem } from '@/models/EventItem';
import { EventRepository } from '@/repositories/EventRepository';
import { ReqPostEventEntry } from '@/gen/api';
import { SubscriptionRepository } from '@/repositories/SubscriptionRepository';
import {
  threeDSecureAuth,
  getThreeDSecureAuthResult
} from '@/common/threeDSecureUtils';
import { getSubscribedPackageIds } from '@/common/subscriptionUtils';
import { ErrorWithCode } from '@/common/customErrors';
import {
  EVENT_TENANT_ID,
  PRODUCT_TENANT_ID,
  INFO_SUBSCRIPTION_CLAIMKEY
} from '@/common/constants';

Component.registerHooks(['beforeRouteEnter']);

@Component({
  components: {
    CreditCardForm,
    SavedCardForm,
    GetSonyPaymentToken
  }
})
export default class P0235 extends Vue {
  beforeRouteEnter(to: any, from: any, next: any) {
    if (from.name === 'event-detail' || getThreeDSecureAuthResult(to.query)) {
      next();
      return;
    }
    next('/events');
  }

  @Prop() propEventItem?: string;
  @Prop() propRequestBody?: string;
  // イベント申込料金区分
  @Prop()
  propEventFeeClassCode?: string;

  // セッションストレージのキー
  readonly KEY_FOR_EVENT_ITEM = 'eventItem';
  readonly KEY_FOR_REQUEST_BODY = 'requestBody';
  readonly KEY_FOR_FEE_CLASS_CODE = 'eventFeeClassCode';

  // イベント情報
  eventItem = {} as EventItem;
  // リクエストボディ
  requestBody = {} as ReqPostEventEntry;
  // イベント料金コード
  eventFeeClassCode = '';
  buttonLoading = false;
  // 保存済みクレジットカード情報（表示用）
  subscriptionInfo = {} as SubscriptionInfo;
  // 入力されたクレジットカード情報
  inputCard: InputCard = {
    number: '',
    expYear: '',
    expMonth: '',
    securityCode: '',
    holderName: ''
  };
  // 保存済みカードのカード名義
  savedCardHolderName = '';
  // エラーメッセージ
  errorMsg = '';
  // initialize時のエラーメッセージ
  initErrorMsg = '';
  // カードトークン
  token = '';
  // 決済ラジオボタンの初期値
  radioSelectedCreditCard = '';
  // 3Dセキュア認証結果
  threeDSecureAuthResult = '';
  // イベント申込時にcreated()の処理を待たずに画面描画されてしまう挙動に対する制御フラグ
  isInitialized = false;
  // 支払合計金額
  payAmount(): number {
    return this.requestBody?.event_options?.reduce((sum, item) => {
      return sum + item.pay_amount;
    }, 0);
  }
  // 選択状態のイベント内選択肢
  selectedEventOptions(): EventOptionItem[] {
    return this.eventItem?.eventOptions?.filter(e => e.isSelected);
  }
  // 新規クレジットカード入力欄の非活性切り替えのため、保存済みカードの選択状況を取得する
  get isSelectedSavedCard() {
    return (
      this.radioSelectedCreditCard === this.$cls.CREDIT_CARD_CLS.SAVED_CARD.CD
    );
  }

  // イベントリポジトリ
  get eventRepo() {
    return new EventRepository();
  }

  // サブスクリポジトリ
  get subscriptionRepo() {
    return new SubscriptionRepository();
  }
  // TypeScriptで$refsを使用すると「TS2339: Property 'xxx' does not exist on type」というエラーが出るため、$refsを上書きする
  $refs!: {
    CreditCardForm: CreditCardForm;
    SavedCardForm: SavedCardForm;
    GetSonyPaymentToken: GetSonyPaymentToken;
  };

  async created() {
    await this.initialize();
    // 処理を待ってから画面描画する
    this.isInitialized = true;
  }

  async initialize() {
    // encryptValue付きの場合は3Dセキュア認証後のリダイレクトと判断し、イベント申込処理を実施する
    this.threeDSecureAuthResult = getThreeDSecureAuthResult(this.$route.query);
    if (this.threeDSecureAuthResult) {
      try {
        await this.$router.push({ query: undefined });
        // eslint-disable-next-line no-empty
      } catch {}
      // 現在と同じページにvue-routerで移動しようとしたときにNavigationDuplicatedエラーが発生するが、クエリパラメータを変更するためには仕方ないのでエラーを許容する
      // created()の中の処理の場合エラーが発生しないが念の為try/catchしておく。
      this.getSessionStorage();
      if (!this.initErrorMsg) {
        await this.register();
      }
      // イベント申込に成功した場合は画面描画する
      if (!this.errorMsg) {
        return;
      }
    } else {
      // encryptValue無しの場合はイベント申込画面を表示する
      // プロパティが渡ってきていない場合エラー
      if (
        !this.propEventItem ||
        !this.propRequestBody ||
        !this.propEventFeeClassCode
      ) {
        this.initErrorMsg = this.$msg.get('2000078');
        return;
      }
      // プロパティを変数に格納
      this.eventItem = EventItem.new(
        JSON.parse(this.propEventItem) as EventItem
      );
      this.requestBody = JSON.parse(this.propRequestBody) as ReqPostEventEntry;
      this.eventFeeClassCode = this.propEventFeeClassCode;
    }
    if (this.isSubscriber()) {
      await this.getRegisterInfo();
    }
    this.setRadioValue();
  }

  // セッションストレージの取得
  getSessionStorage() {
    try {
      // セッションストレージから情報を取得
      const eventItemStr = sessionStorage.getItem(this.KEY_FOR_EVENT_ITEM);
      const requestBodyStr = sessionStorage.getItem(this.KEY_FOR_REQUEST_BODY);
      this.eventFeeClassCode =
        sessionStorage.getItem(this.KEY_FOR_FEE_CLASS_CODE) ?? '';
      // セッションストレージは消しておく
      this.clearSessionStorage();
      if (!eventItemStr || !requestBodyStr || !this.eventFeeClassCode) {
        // 該当するキー自体が存在しない、またはその値が空文字かnull
        this.initErrorMsg = this.$msg.get('2000091');
        return;
      }
      this.eventItem = EventItem.new(JSON.parse(eventItemStr) as EventItem);
      this.requestBody = JSON.parse(requestBodyStr) as ReqPostEventEntry;
    } catch {
      // セッションストレージからの情報取得やパースに失敗した場合はエラーを表示する
      this.initErrorMsg = this.$msg.get('2000091');
      return;
    }
  }

  // サブスク登録中フラグ
  isSubscriber(): boolean {
    return (
      getSubscribedPackageIds(this.$auth.user[INFO_SUBSCRIPTION_CLAIMKEY])
        .length > 0
    );
  }

  // サブスク登録情報を取得する
  async getRegisterInfo() {
    await this.subscriptionRepo
      .getSubscriptionInfo()
      .then(res => {
        this.subscriptionInfo = res;
      })
      .catch((errCode: number) => {
        this.handleGetRegisterInfoErr(errCode);
      });
  }

  handleGetRegisterInfoErr(errCode: number) {
    switch (errCode) {
      case 42200:
        this.errorMsg = this.$msg.get('2000074', {
          errorCode: errCode
        });
        break;
      case 42206:
        this.errorMsg = this.$msg.get('2000074', {
          errorCode: errCode
        });
        break;
      case 50000:
        this.errorMsg = this.$msg.get('2000071', {
          errorCode: errCode
        });
        break;
      case 50001:
        this.errorMsg = this.$msg.get('2000071', {
          errorCode: errCode
        });
        break;
      default:
        this.errorMsg = this.$msg.get('2000078');
        break;
    }
  }

  setRadioValue() {
    // 保存済みカードが存在する場合は、デフォルトで保存済みカードを選択
    this.radioSelectedCreditCard =
      this.subscriptionInfo && this.subscriptionInfo.maskedCardNumber
        ? this.$cls.CREDIT_CARD_CLS.SAVED_CARD.CD
        : this.$cls.CREDIT_CARD_CLS.ANOTHER_CARD.CD;
  }

  // クレジットカード選択ラジオボタン選択
  selectCreditCardRadio(event: any) {
    // 保存済を選択した場合、カード情報入力部分を非活性化・入力値の削除・バリデーションエラーの削除を行う
    this.radioSelectedCreditCard = event.target.value;
    if (
      this.radioSelectedCreditCard === this.$cls.CREDIT_CARD_CLS.SAVED_CARD.CD
    ) {
      this.inputCard.number = '';
      this.inputCard.expYear = '';
      this.inputCard.expMonth = '';
      this.inputCard.securityCode = '';
      this.inputCard.holderName = '';
      this.$refs.CreditCardForm.$validator.reset();
    } else {
      // 別のカードで支払うを選択した場合、入力値の削除・バリデーションエラーの削除を行う
      this.savedCardHolderName = '';
      this.$refs.SavedCardForm.$validator.reset();
    }
  }

  handleRegisteringMethod() {
    this.buttonLoading = true;
    this.errorMsg = '';
    // 保存済みカードで支払う場合
    if (
      this.radioSelectedCreditCard === this.$cls.CREDIT_CARD_CLS.SAVED_CARD.CD
    ) {
      this.$refs.SavedCardForm.$validator.validateAll().then(valid => {
        if (valid) {
          this.threeDSecureAuthCaller();
        } else {
          this.buttonLoading = false;
        }
      });
      // 新規カードで支払う場合
    } else {
      this.$refs.CreditCardForm.$validator.validateAll().then(valid => {
        if (valid) {
          this.getPaymentToken();
        } else {
          this.buttonLoading = false;
        }
      });
    }
  }

  // 3Dセキュア認証の共通関数呼び出し
  async threeDSecureAuthCaller() {
    const redirectUrl = `${process.env.VUE_APP_SERVICE_URL}/register-event`;
    // 3Dセキュア認証後本画面にリダイレクトした際にプロパティを参照するため、セッションストレージにプロパティを保存
    this.setSessionStorage();
    try {
      await threeDSecureAuth(
        redirectUrl,
        this.eventItem.productFlg ? PRODUCT_TENANT_ID : EVENT_TENANT_ID,
        this.payAmount(),
        this.token ? this.inputCard.holderName : this.savedCardHolderName,
        this.token ? this.token : undefined
      );
    } catch (e) {
      this.buttonLoading = false;
      this.clearSessionStorage();
      if (e instanceof ErrorWithCode) {
        switch (e.code) {
          case 40017:
          case 40004:
            this.errorMsg = this.$msg.get('2000074', {
              errorCode: e.code
            });
            break;
          case 50000:
            this.errorMsg = this.$msg.get('2000071', {
              errorCode: e.code
            });
            break;
          default:
            this.errorMsg = this.$msg.get('2000091');
        }
        return;
      }
      this.errorMsg = this.$msg.get('2000091');
    }
  }

  setSessionStorage() {
    sessionStorage.setItem(
      this.KEY_FOR_EVENT_ITEM,
      JSON.stringify(this.eventItem) ?? ''
    );
    sessionStorage.setItem(
      this.KEY_FOR_REQUEST_BODY,
      JSON.stringify(this.requestBody) ?? ''
    );
    sessionStorage.setItem(
      this.KEY_FOR_FEE_CLASS_CODE,
      this.eventFeeClassCode ?? ''
    );
  }

  async register() {
    // リクエストボディに3Dセキュア認証結果を付与
    this.requestBody.three_d_secure_auth_result = this.threeDSecureAuthResult;
    try {
      await this.eventRepo.postEventEntry(this.requestBody);
      await this.$router.push({
        name: 'register-event-complete',
        params: {
          propEventItem: JSON.stringify(this.eventItem),
          propRequestBody: JSON.stringify(this.requestBody),
          propEventFeeClassCode: this.eventFeeClassCode
        }
      });
    } catch (errCode) {
      this.handleRegisterErr(errCode);
    }
  }

  getPaymentToken() {
    this.$refs.GetSonyPaymentToken.getPaymentToken(
      this.inputCard.number,
      this.inputCard.expYear,
      this.inputCard.expMonth,
      this.inputCard.securityCode
    );
  }

  handleToken(token: string, err: any) {
    if (err) {
      // サーバエラーが発生しました。時間を空けて再度お試しください。
      this.errorMsg = this.$msg.get('2000011');
      this.buttonLoading = false;
    } else {
      this.token = token;
      this.threeDSecureAuthCaller();
    }
  }

  // handleRegisterErrメソッドのcomplexityのエラーを回避できないため、disableする
  // eslint-disable-next-line complexity
  private handleRegisterErr(errCode: any) {
    switch (errCode) {
      case 40000:
        this.errorMsg = this.$msg.get('2000091');
        break;
      case 40001:
      case 40002:
      case 40003:
        this.errorMsg = this.$msg.get('2000092', {
          errorCode: errCode
        });
        break;
      case 40004:
      case 40018:
      case 40019:
        this.errorMsg = this.$msg.get('2000074', {
          errorCode: errCode
        });
        break;
      case 42200:
      case 42201:
      case 42202:
      case 42203:
        this.errorMsg = this.$msg.get('2000070', {
          errorCode: errCode
        });
        break;
      case 42204:
      case 42214:
        this.errorMsg = this.$msg.get('2000071', {
          errorCode: errCode
        });
        break;
      case 42207:
        this.errorMsg = this.$msg.get('2000095');
        break;
      case 42208:
        this.errorMsg = this.$msg.get('2000096');
        break;
      case 42209:
        this.errorMsg = this.$msg.get('2000097');
        break;
      case 42211:
        this.errorMsg = this.$msg.get('2000098');
        break;
      case 42212:
        this.errorMsg = this.$msg.get('2000094');
        break;
      case 42213:
        this.errorMsg = this.$msg.get('2000120');
        break;
      case 50000:
      case 50001:
      case 50011:
      case 50012:
        this.errorMsg = this.$msg.get('2000071', {
          errorCode: errCode
        });
        break;
      default:
        this.errorMsg = this.$msg.get('2000091');
        break;
    }
  }

  // セッションストレージ削除
  clearSessionStorage() {
    sessionStorage.removeItem(this.KEY_FOR_EVENT_ITEM);
    sessionStorage.removeItem(this.KEY_FOR_REQUEST_BODY);
    sessionStorage.removeItem(this.KEY_FOR_FEE_CLASS_CODE);
  }
}
